export const getErrorMessage = (res) => {
  if (res?.data?.errors && Object.keys(res.data.errors).length > 0)
    return Object.entries(res.data.errors)
      .map(([key, value]) => `\n - ${key}: ${value}`)
      .join('');
  return res.data?.error_message || res.statusText || 'Internal Error';
};
